import { createUseStyles } from 'react-jss';

import { FontWeight, ITheme, mediaQuery } from '../../../../styles';

const useStyles = createUseStyles<string, { buttonGreen: boolean; hasWidgetUrl: boolean }, ITheme>(
  ({ breakpoints }: ITheme) => ({
    svgIcon: {
      width: 24,
      height: 24,
      marginRight: 8,
      '& > svg': {
        margin: 'auto',
        paddingTop: 4,
      },
      '&:hover': {
        cursor: 'pointer',
      },
    },
    title: {
      fontSize: 20,
      fontWeight: 700,
      display: 'inline-block',
      marginBottom: 8,
    },
    text: {
      display: 'block',
      marginTop: 16,
      fontSize: 14,
      fontWeight: FontWeight.Bold,
      color: 'var(--x-text-color-1)',
    },
    previewButtonContainer: {
      padding: ({ hasWidgetUrl }) => (hasWidgetUrl ? '0px' : '24px 18px'),
      backgroundColor: 'var(--x-bg-5)',
      borderRadius: 16,
      marginTop: 8,
    },
    widgetCodeHolder: {
      height: 332,
    },
    codeContainer: {
      border: '1px solid #CBCBCB',
      borderRadius: 12,
      padding: 16,
    },
    widgetCode: {
      fontWeight: FontWeight.SemiBold,
      fontSize: 14,
      maxHeight: 100,
      color: '#949494',
      display: 'inline-block',
      maxWidth: 340,
      wordWrap: 'break-word',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      [mediaQuery(breakpoints.mobile)]: {
        maxWidth: 279,
      },
    },
    copyButton: {
      display: 'block',
      margin: 'auto',
      width: '100%',
      marginTop: 10,
      padding: [6, 0],
      backgroundColor: ({ buttonGreen }) => buttonGreen && 'var(--x-bg-10)',
      '&:hover': {
        backgroundColor: ({ buttonGreen }) => buttonGreen && 'var(--x-bg-10)',
      },
      '& > span': {
        fontSize: 14,
        display: 'block',
        margin: 'auto',
        marginTop: 0,
        marginBottom: 0,
      },
    },
  }),
  {
    name: 'embed-modal',
  },
);

export default useStyles;
